/* eslint-disable react/jsx-no-duplicate-props */
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { mainColor } from '../../constants';
import { ChangeEventHandler, MouseEventHandler } from 'react';

const styles = {
  root: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: mainColor.secondaryColor
      }
    },
    '& .MuiInputBase-root.Mui-disabled:before': {
      borderBottomStyle: 'solid'
    },

  },
  label: {
    '&$focused': {
      color: '#009973'
    },
    '&$error': {
      color: 'red'
    }
  },
  input: {
    '&:after': {
      borderBottom: `2px solid #009973`
    },

    '&[type="time"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer !important'
    }
  },
  focused: {},
  cssFocused: {},
  notchedOutline: {},
  error: {}
};


type InputProps = {
  value?: string, onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  type?: string,
  label?: string,
  margin?: any,
  autoFocus?: boolean,
  id?: string,
  classes?: {
    [key: string]: string
  }
  fullWidth?: boolean,
  className?: any,
  disabled?: boolean,
  style?: any,
  InputProps?: any,
  error?: any,
  onFocus?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  onBlur?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  variant?: any,
  rows?: number,
  multiline?: boolean,
  placeholder?: string,
  maxLength?: number,
  InputLabelProps?: any
  cursor?: string
  onClick?: MouseEventHandler<HTMLDivElement | HTMLInputElement>;
};
function Input({ value, onChange, type, label, margin, autoFocus, id, classes, fullWidth, className, disabled, style, InputProps, error, onFocus, onBlur, variant, rows, multiline, placeholder, maxLength, InputLabelProps, cursor, onClick }: InputProps) {
  return (
    <TextField
      autoFocus={autoFocus}
      margin={margin}
      label={label}
      type={type}
      value={value}
      onChange={onChange}
      onClick={onClick}
      fullWidth={fullWidth}
      id={id}
      disabled={disabled}
      style={style}
      className={className}
      multiline={multiline}
      variant={variant}
      onFocus={onFocus}
      onBlur={onBlur}
      rows={rows}
      placeholder={placeholder}
      error={error}
      InputProps={{
        classes: {
          ...(variant === 'standard'
            ? { underline: classes?.input }
            : { root: classes?.input }),
          ...InputProps?.classes,
          input: classes?.input
        },
        ...InputProps
      }}

      inputProps={{
        ...(maxLength ? { maxLength } : {}),
        style: { ...(cursor ? { cursor } : {}) },
      }}
      InputLabelProps={{
        classes: {
          root: classes?.label,
          focused: classes?.focused,
          error: classes?.error
        },
        ...InputLabelProps
      }}
    />
  );

}

export default withStyles(styles)(Input);
